// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"c6600395","453":"e19e7407","684":"8149a1f6","924":"b5b71f41"}[chunkId] + ".chunk.js";
};